import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withHandlers } from 'recompose';

import { getActiveShop, getActiveType, getBarberUser } from '../../../auth/selectors';
import DownloadButton from '../components/DownloadButton';
import { downloadCashRegisterHistory } from '../actions';
import withOwnerTypeAndId from '../../../common/hoc/withOwnerTypeAndId';
import { fullName } from '../../../common/helpers/users';

const DownloadButtonContainer = compose(
  withOwnerTypeAndId,
  connect(
    state => ({
      shop: getActiveShop(state),
      barber: getBarberUser(state),
      activeType: getActiveType(state),
    }),
  ),
  withHandlers({
    downloadHistory: ({
      ownerType,
      ownerId,
      shop,
      barber,
      activeType,
    }) => () => {
      const name = activeType === 'barber' ? fullName(barber) : shop.name;

      return downloadCashRegisterHistory(ownerType, ownerId, name);
    },
  }),
);

export default DownloadButtonContainer(DownloadButton);
